import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { LogicData, Redis } from './redis';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgTemplateOutlet } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'redis';

@Component({
    selector: 'app-redis',
    templateUrl: './redis.component.html',
    styleUrls: ['./redis.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, MatSelect, MatOption, NgTemplateOutlet, CMSComponent, NextSelectorComponent]
})
export class RedisComponent extends NodeBuilder implements OnInit {

  redisForm: UntypedFormGroup;
  logicForm: UntypedFormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: { [index: string]: any }) {
    const redisForms = Redis.toForm(stepData, this.canEdit);
    this.redisForm = redisForms.RedisForm;
    this.logicForm = redisForms.LogicForm;

    if (this.redisForm.get('yes').value === newStepValue) {
      this.redisForm.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.redisForm.get('no').value === newStepValue) {
      this.redisForm.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const formData = this.redisForm.getRawValue();
    const logicData = this.logicForm?.getRawValue();
    return new Redis(formData, logicData).nodeData;
  }

  get isNodeValid(): boolean {
    this.redisForm.markAllAsTouched();
    if (this.logicForm) {
      this.logicForm.markAllAsTouched();
    }
    return this.redisForm.valid && this.logicForm.valid;
  }

  public actionChange(actionName: string) {
    const logicData: LogicData = {
      key: '',
      expire: '',
      value: '',
    };
    this.logicForm = Redis.buildLogicForm(logicData, actionName, this.canEdit.canEditFlows);
  }

  protected readonly name = name;
}
